export default __webpack_public_path__ + "static/media/Frame (1).64d3b9c1.svg";